// extracted by mini-css-extract-plugin
export default {"subtitle":"subtitle__PI6i8","__view-primary":"__view-primary__UtVRt","__view-primary-on-color":"__view-primary-on-color__SxYUB","__view-custom":"__view-custom__VyXEl"};